<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Load Saved Screens</p>
      <button
        type="button"
        class="delete"
        v-on:click="$parent.close()"/>
    </header>
      <div class="modal-card-body">
      <p v-show="savedScreens.loaded && savedScreens.a.length === 0">
        You have no saved screens, use the Save button to create one.
      </p>
      <div v-show="savedScreens.a.length > 0 || !savedScreens.loaded">
        <p>Choose a saved set of screens to use:</p>
        <b-table
          v-bind:data="savedScreens.a"
          v-bind:loading="!savedScreens.loaded"
        >
          <b-table-column field="name" label="Name" sortable searchable v-slot="props">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column field="metrics" label="Screens Applied" sortable v-slot="props">
            {{ props.row.metrics.length }}
          </b-table-column>
          <b-table-column field="created_at" label="Created" sortable v-slot="props">
            {{ new Date(props.row.created_at).toLocaleString() }}
          </b-table-column>
          <b-table-column
            field="name"
            label="Launch"
            sortable
            v-slot="props"
          >
            <button
              class="button is-small"
              v-on:click="$root.$emit('loaded-screenset', props.row); $parent.close();"
            >
              Open
            </button>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    savedScreens: Object,
    parent: Object,
  }
}
</script>
